import type { FaireProductEntity } from "../../entity_types/product";

export const p_hq9bejqrzp: FaireProductEntity = {
  token: "p_hq9bejqrzp",
  type: "product",
  name: "Eating the Alphabet Board Book : Lois Ehlert",
  brandToken: "b_brkasb91",
  brandName: "HarperCollins",
  imageUrl:
    "https://cdn.faire.com/fastly/78c6cda4edbb2c92afc4e61120724fa2fc8ef6a720bc477353bf793b838b2511.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description:
    "Fruits & Vegetables from A to Z \nBoard Book \nJUVENILE NONFICTION/Concepts / Alphabet \n\nA vibrant and sturdy word book featuring fruits and vegetables from around the world from Caldecott Honor–winning author-illustrator Lois Ehlert, featuring upper-- and lowercase letters for preschoolers just learning language. Apple to Zucchini, come take a look. Start eating your way through this alphabet book.  Each turn of the page reveals a mouth-watering arrangement of foods: Indian corn, jalapeno, jicama, kumquat, kiwifruit and kohlrabi. Lois Ehlert's lively watercolors, paired with bold easy-to-read type make for a highly appealing and accessible book for parents and children to devour. At the end of the book, Ehlert provides a detailed glossary that includes pronunciation, botanical information, the origin and history of the particular plant and occasional mythological references, with a small watercolor picture to remind the reader of what the plant looks like.",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:56.734Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
